module.exports = __webpack_public_path__ + "static/img/91BM-051-MaxCai.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-051-MaxCai.jpg
// module id = NOG0
// module chunks = 0